import { render } from "./crop-area.vue?vue&type=template&id=460fe44a"
const script = {}

import exportComponent from "/home/herman/Документи/Work/UHMI/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__